import React from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import ReportsList from './ReportsList';
import HelpdeskReports from './HelpdeskReports';
import RequisitionsReports from './RequisitionsReports';
import PendingRequisitionsReports from './PendingRequisitionsReports';
import RFQReports from './RFQReports';
import ChangesReports from './ChangesReports';
import ChatReports from './ChatReports';
import AutomatedActivityReports from './AutomatedActivityReports';

function Reports() {
  return (
    <Routes>
      <Route path="/" element={<ReportsList />} />
      
      {/* Communication Reports */}
      <Route path="/chat" element={<ChatReports />} />
      
      {/* Procurement Reports */}
      <Route path="/requisitions" element={<RequisitionsReports />} />
      <Route path="/pending-requisitions" element={<PendingRequisitionsReports />} />
      <Route path="/rfq" element={<RFQReports />} />
      
      {/* Administration Reports */}
      <Route path="/automated-activity" element={<AutomatedActivityReports />} />
      <Route path="/changes" element={<ChangesReports />} />
      
      {/* Support Reports */}
      <Route path="/helpdesk" element={<HelpdeskReports />} />
      
      {/* Legacy Routes for Backward Compatibility */}
      <Route path="/pending_requisitions" element={<PendingRequisitionsReports />} />
      <Route path="/automated_activity" element={<AutomatedActivityReports />} />
      
      <Route path="*" element={<Navigate to="/reports" replace />} />
    </Routes>
  );
}

export default Reports; 